import { Flex, FlexProps } from "@mantine/core";
import { CSSProperties } from "react";

import {
  MuiResponsiveValue,
  useMuiResponsiveValue,
} from "~/hooks/useMuiResponsiveValue";
import { DEFAULT_BORDER_RADIUS } from "~/utils/Constants";

// Bordered content card (padding 16, 1px border, 0.5rem radius, full width).
// Lays out children like the legacy MUI Stack (flex column). The MUI-era prop
// aliases (spacing/alignItems/justifyContent/width/height) are kept during
// the MUI → Mantine migration and renamed page by page.
export type ContentWrapperProps = Omit<FlexProps, "gap"> & {
  spacing?: number;
  gap?: FlexProps["gap"];
  alignItems?: CSSProperties["alignItems"];
  justifyContent?: CSSProperties["justifyContent"];
  width?: CSSProperties["width"];
  height?: CSSProperties["height"];
  gridColumn?: MuiResponsiveValue<CSSProperties["gridColumn"]>;
  gridRow?: CSSProperties["gridRow"];
  gridTemplateColumns?: CSSProperties["gridTemplateColumns"];
  gridGap?: CSSProperties["gridGap"];
};

const ContentWrapper = ({
  spacing,
  gap,
  direction = "column",
  align,
  justify,
  alignItems,
  justifyContent,
  width,
  height,
  w,
  h,
  gridColumn,
  gridRow,
  gridTemplateColumns,
  gridGap,
  style,
  ...rest
}: ContentWrapperProps) => {
  const resolvedGridColumn = useMuiResponsiveValue(gridColumn);

  return (
    <Flex
      direction={direction}
      gap={gap ?? (spacing !== undefined ? spacing * 8 : undefined)}
      align={align ?? alignItems}
      justify={justify ?? justifyContent}
      w={w ?? width ?? "100%"}
      h={h ?? height}
      p={16}
      style={{
        backgroundColor: "var(--mantine-color-bg-primary)",
        border: "1px solid var(--mantine-color-border-secondary)",
        borderRadius: DEFAULT_BORDER_RADIUS,
        gridColumn: resolvedGridColumn,
        gridRow,
        gridTemplateColumns,
        gridGap,
        ...style,
      }}
      {...rest}
    />
  );
};

export default ContentWrapper;
